import React, { useEffect, useState } from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow, 
  Paper, 
  TableContainer,
  Collapse,
  IconButton,
  Box,
  Typography,
  Button
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { formatAmount } from '../../../utils/formatAmount';
import useManageStock from './useManageStock';
import { useManageExport } from '../export/useManageExport';
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment-timezone';


// Row component to handle expansion
const StockRow = ({ stock }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{stock.skuCode}</TableCell>
        <TableCell>{stock.name}</TableCell>
        <TableCell align="right">{stock.totalQty}</TableCell>
        <TableCell align="right">{formatAmount(stock.averageUnitPrice)}</TableCell>
        <TableCell align="right">{formatAmount(stock.totalValue)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Lot Details
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Lot Date</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Unit Price</TableCell>
                    <TableCell align="right">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stock.lots.map((lot, index) => (
                    <TableRow key={index}>
                      <TableCell>{lot.date}</TableCell>
                      <TableCell align="right">{lot.qty}</TableCell>
                      <TableCell align="right">{formatAmount(lot.unitPrice)}</TableCell>
                      <TableCell align="right">{formatAmount(lot.qty * lot.unitPrice)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const StockBalance = () => {
  const { getStockBalance, stockBalance } = useManageStock();
  const { exportStockBalance } = useManageExport();
  const [exportDate, setExportDate] = useState(new Date());

  useEffect(() => {
    getStockBalance();
  }, []);

  useEffect(() => {
    console.log(stockBalance)
  }, [stockBalance])
  
  const handleExport = async () => {
    const formattedDate = moment(exportDate).format('YYYY-MM-DD');
    const response = await exportStockBalance({ asOfDate: formattedDate });
    if (response === true) {
      toast.success("Export successful!");
    } else {
      toast.error(response);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2>Stock Balance</h2>
        <div className="flex items-center space-x-2">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Balance Date"
              value={exportDate}
              onChange={(newDate) => setExportDate(newDate)}
              slotProps={{ textField: { size: 'small' } }}
            />
          </LocalizationProvider>
          <Button
            variant="contained"
            color="primary"
            onClick={handleExport}
          >
            Export
          </Button>
        </div>
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: '#96baf2' }}>
              <TableCell width={50} /> {/* For expand/collapse */}
              <TableCell>SKU Code</TableCell>
              <TableCell>Name</TableCell>
              <TableCell align="right">Total Quantity</TableCell>
              <TableCell align="right">Average Unit Price</TableCell>
              <TableCell align="right">Total Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stockBalance && stockBalance.length > 0 && stockBalance.map((stock, index) => (
              <StockRow key={index} stock={stock} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default StockBalance; 